import { Outlet } from "react-router-dom";
import React, { useState, useEffect } from 'react';
import AppAppBar from "./AppAppBar";

function HeaderNav(props){

    console.log('HeaderNav render - token:', props.token, 'isAdmin:', props.isAdmin);

    return(
        <>
        <div className="gridSpacer"></div>
        <div className="gridHeader">
        { props.token!==""?
        <AppAppBar token={props.token} setToken={props.setToken} isAdmin={props.isAdmin} clearAllData={props.clearAllData}></AppAppBar>
            :<></>
        }
        </div>
        <div className="gridBody">
        <Outlet/>
        </div>
        <div className="gridFooter"></div>
        </>
    );
}

export default HeaderNav;